import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function GroupPanel(props){

    const history = useHistory();
    
    function navigate(link){
        history.push(`/group/${link}`);
    }

    return (
        <div className="GroupPanel" onClick={()=>navigate(props.link)}>
            <div className="PanelText">
                <h3>{props.title}</h3>
                <p>{props.subtitle}</p>
            </div>
            <div className="PanelImg">
                <LazyLoadImage 
                    src={props.img.src} 
                    alt={props.img.alt}
                />
            </div>
        </div>
    );
}

export default GroupPanel;